export const PATIENT_REGISTRATION_DETAILS_LOAD_SUCCESS = 'PATIENT_REGISTRATION_DETAILS_LOAD_SUCCESS';
export const LOAD_REMINDERSETTINGS = 'LOAD_REMINDERSETTINGS';
export const LOAD_PATIENT_REMINDERSETTINGS = 'LOAD_PATIENT_REMINDERSETTINGS';
export const SET_NOTIFICATION_EMAIL = 'SET_NOTIFICATION_EMAIL';
export const UPDATE_NOTIFICATION_FORMINPUT = 'UPDATE_NOTIFICATION_FORMINPUT';
export const DISABLE_APPOINTMENTSMS = 'DISABLE_APPOINTMENTSMS';
